export const OPEN_ORDER_DETAILS_MODAL = 'OPEN_ORDER_DETAILS_MODAL'
export const GET_STORE_DETAILS = 'GET_STORE_DETAILS'
export const GET_SOUND_ENABLED_STATUS = 'GET_SOUND_ENABLED_STATUS'
export const ENABLE_NOTIFICATION_SOUNDS = 'ENABLE_NOTIFICATION_SOUNDS'
export const DISABLE_NOTIFICATION_SOUNDS = 'DISABLE_NOTIFICATION_SOUNDS'
export const FORCE_REFRESH = 'FORCE_REFRESH'

/** sessionStorage key used to pass force-update payload from the bridge handler to the /app-update route guard */
export const FORCE_UPDATE_SESSION_KEY = '__force_update_payload'
